import { Dispatch } from 'react-redux';
import { AxiosError } from "axios";

import { AuthActionCreators, IApplicationState } from ".";
import { IAutomatedJob, IBaseResponse, ICron } from "../models";

export interface IQaCron extends ICron {
    taskName: string,
    testVariableKey: string,
    alternateRun: {
        methodName: string,
        description: string
    }
}

export const ActionTypes = {
    SET_AUTOMATED_JOBS: "SET_AUTOMATED_JOBS"
}

export interface IAutomatedJobListResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            logs: IAutomatedJob[],
            crons: ICron[]
        }
    }
}

export interface ICronListResponse {
    data: {
        success: boolean,
        message: string,
        results: ICron[]
    }
}

export interface IQaCronListResponse {
    data: {
        success: boolean,
        message: string,
        results: IQaCron[]
    }
}

export interface IManualRunResponse {
    data: {
        success: boolean,
        message: string,
        results: number
    }
}

export const ActionCreators = {
    getAutomatedJobs: (isOps: boolean): any => (dispatch: Dispatch<IApplicationState>): Promise<IAutomatedJobListResponse> => {
        let url = __API__ + "/automated-job";
        let opsUrl = __API__ + "/public/command-center/automated-jobs";

        var options = {
            url: !isOps ? url : opsUrl
        };

        if (!isOps) {
            return dispatch(AuthActionCreators.apiGet(options))
                .then((response: IAutomatedJobListResponse) => {
                    if (response.data.success)
                        dispatch(ActionCreators.setAutomatedJobs(response.data.results));

                    return Promise.resolve(response);
                })
                .catch((error: AxiosError) => {
                    throw error;
                });
        } else {
            return dispatch(AuthActionCreators.apiGetPublic(options))
                .then((response: IAutomatedJobListResponse) => {
                    if (response.data.success)
                        dispatch(ActionCreators.setAutomatedJobs(response.data.results));

                    return Promise.resolve(response);
                })
                .catch((error: AxiosError) => {
                    throw error;
                })
                ;
        }
    },
    setAutomatedJobs: (results: { logs: IAutomatedJob[], crons: ICron[] }) => {
        let { logs, crons } = results;

        return {
            type: ActionTypes.SET_AUTOMATED_JOBS,
            logs,
            crons
        };
    },

    getCronList: () => async (dispatch: Dispatch<IApplicationState>): Promise<ICronListResponse> => {
        var options = {
            url: __API__ + "/automated-job/cron"
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    getQaCronList: () => async (dispatch: Dispatch<IApplicationState>): Promise<IQaCronListResponse> => {
        var options = {
            url: __API__ + "/automated-job/cron/qa"
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    runManually: (id: number, alternate: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<IManualRunResponse> => {
        var options = {
            url: `${__API__}/automated-job/cron/${id}/run-manually?alternate=${alternate}`
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
}

export interface IAutomatedJobState {
    list: IAutomatedJob[],
    crons: ICron[]
}

var initialState: IAutomatedJobState = {
    list: [],
    crons: []
};

interface ISetLogs {
    type: string,
    logs: IAutomatedJob[],
    crons: ICron[]
}

const setAutomatedJobs = (state: IAutomatedJobState, action: ISetLogs) => {
    state.list = action.logs;
    state.crons = action.crons;
    return state;
}

const createReducer = (initialState: IAutomatedJobState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = Object.assign({}, state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
    [ActionTypes.SET_AUTOMATED_JOBS]: setAutomatedJobs
};

export const Reducer = createReducer(initialState, handlers);
